import { ALL_CONTENT, Title } from "../resources";
import type { OnProgress } from ".";
import type { TitleEntity } from "../types";

export async function getAllTitles(
  ids: string[],
  tokenGetter?: () => Promise<string>,
  onProgress?: OnProgress,
) {
  const allTitles: TitleEntity[] = [];
  const limit = 100;
  const dedupedIds = ids.dedupe();
  let offset = 0;

  while (true) {
    const titles = await Title.search(
      {
        ids: dedupedIds.slice(offset, offset + limit),
        includes: ["cover_art", "organization"],
        contentRating: ALL_CONTENT,
        limit: limit,
      },
      await tokenGetter?.(),
    );

    allTitles.push(...titles.data);
    onProgress?.(Math.min(1, (offset + limit) / dedupedIds.length));

    if (offset + limit >= dedupedIds.length) {
      break;
    }

    offset += limit;
  }

  return allTitles;
}
